module.exports = __webpack_public_path__ + "img/gys_10@2x.111a3c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_10@2x.png
// module id = 7Dbx
// module chunks = 0